<template>
    <div :class="'img-' + size" class="custom-icon">
		<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M3.969 120.25c16.316 0 28.547-7.826 34.6-12.65 8.048 3.028 16.98 4.775 26.431 4.775 34.798 0 63-22.911 63-51.188C128 32.912 99.798 10 65 10S2 32.911 2 61.188c0 12.206 5.267 23.378 14.027 32.164-3.076 12.403-13.362 23.453-13.486 23.576a1.956 1.956 0 00-.369 2.14 1.927 1.927 0 001.797 1.182z" class="path" stroke="#0C2340"/><path d="M33.5 53.313a7.866 7.866 0 017.875 7.874 7.866 7.866 0 01-7.875 7.876 7.866 7.866 0 01-7.875-7.876 7.866 7.866 0 017.875-7.874zm31.5 0a7.866 7.866 0 017.875 7.874A7.866 7.866 0 0165 69.064a7.866 7.866 0 01-7.875-7.876A7.866 7.866 0 0165 53.313zm31.5 0a7.866 7.866 0 017.875 7.874 7.866 7.866 0 01-7.875 7.876 7.866 7.866 0 01-7.875-7.876 7.866 7.866 0 017.875-7.874z" class="highlight" stroke="#00BBDC"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>